export default "/images/image_10.jpg?fd94c3226627a7a8f124417f7d9d7001";